import { render } from "./LinkedIcon.vue?vue&type=template&id=8b0744ae"
import script from "./LinkedIcon.vue?vue&type=script&lang=js"
export * from "./LinkedIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__